import { CommentsData } from '@/types/comments'

export const COMMENT_MAXIMUM_CHARACTERS = 500

export const REPORT_REASON_VALUES = [
  'hate-speech',
  'bullying-or-harassment',
  'threats-or-incitement-of-violence',
  'promoting-or-glorifying-self-harm',
  'spam-or-scams',
  'illegal-content',
  'sharing-private-or-personal-information',
  'other',
] as const

export type ReportReason = (typeof REPORT_REASON_VALUES)[number]

export const EMPTY_COMMENTS_DATA: CommentsData = {
  results: [],
  pages: { total: 0, limit: 0, prev: '', next: '' },
}
